import React, { useState, useEffect } from "react";
import {
  Container,
  Button,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Spinner,
  Table,
  Progress,
} from "reactstrap";
import axios from "axios";
import classnames from "classnames";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useTable, useSortBy } from "react-table";
import { useParams } from "react-router-dom";
import SbomReport from "./sbomreport";
import SummaryTab from "./summarytab";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import VulnerabilitySummary from "./tablesbom";
import logopath from "../../../assets/images/logo-dark.png";
import { get } from "lodash";
import { getVulnerabilityScanData } from "../../../common/data/demo/reports";
const generateRandomData = (jsonData) => {
  let flattenedData = [];

  Object.keys(jsonData.vulnerabilities).forEach((hostKey) => {
    const hostVulnerabilities = jsonData.vulnerabilities[hostKey];

    hostVulnerabilities.forEach((vulnerability) => {
      flattenedData.push({
        risk: vulnerability.risk_factor,
        host: hostKey,
        port: vulnerability.port,
        name: vulnerability.name,
        synopsis: vulnerability.synopsis,
        description: vulnerability.description,
        solution: vulnerability.solution,
      });
    });
  });

  return flattenedData;
};

const calculateRiskDistribution = (scanData) => {
  const riskLevels = ["High", "Medium", "Low", "None"];
  const riskDistribution = {};

  scanData.forEach((row) => {
    if (!riskDistribution[row.host]) {
      riskDistribution[row.host] = {
        High: 0,
        Medium: 0,
        Low: 0,
        None: 0,
        Null: 0,
      };
    }

    const risk = row.risk === null ? "Null" : row.risk;
    riskDistribution[row.host][risk] += 1;
  });

  Object.keys(riskDistribution).forEach((host) => {
    const total = Object.values(riskDistribution[host]).reduce((a, b) => a + b, 0);
    riskDistribution[host] = {
      ...riskDistribution[host],
      total,
    };
  });

  return riskDistribution;
};

const fetchScanResults = async (userId, scanId) => {
  try {
    const response = await axios.get(
      `https://api.compliance.cx/api/vulnerability-scan/${userId}//${scanId}`
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    if(userId === "demo"){
    return getVulnerabilityScanData(scanId);
    }
    console.error("Error fetching scan results:", error);
    throw error;
  }
};
const logoUrl = new URL('../../../assets/images/logo-dark.png', import.meta.url).href;


const ScanResults = () => {
  document.title = "Scan Results";
  const { scanId } = useParams();
  const [scanName, setScanName] = useState("");
  const [scanType, setScanType] = useState("");
  const [activeTab, setActiveTab] = useState("summary");
  const [scanData, setScanData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [jsonData, setJsonData] = useState(null);




  const obj = JSON.parse(localStorage.getItem("authUser"));
  const userId = obj.username;
  const [isExporting, setIsExporting] = useState(false);

  const calculateTotalsByRisk = (scanData) => {
    const totals = {
      High: 0,
      Medium: 0,
      Low: 0,
      None: 0
    };

    scanData.forEach(item => {
      if (item.risk) {
        totals[item.risk] = (totals[item.risk] || 0) + 1;
      }
    });

    return totals;
  };

  const exportReport = () => {
    setIsExporting(true);
    const riskTotals = calculateTotalsByRisk(scanData);
    const totalIssues = Object.values(riskTotals).reduce((a, b) => a + b, 0);
    
    // Calculate total risk score
    const riskWeights = {
      Critical: 10,
      High: 8,
      Medium: 5,
      Low: 2,
      None: 0
    };
    
    const totalRiskScore = Object.entries(riskTotals).reduce((score, [risk, count]) => {
      return score + (riskWeights[risk] || 0) * count;
    }, 0);
  
    // Get top vulnerabilities
    const topVulnerabilities = scanData
      .sort((a, b) => riskWeights[b.risk] - riskWeights[a.risk])
      .slice(0, 5);
  
    const getBase64Image = async (imgUrl) => {
      try {
        const response = await fetch(imgUrl);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error('Error converting image to base64:', error);
        return '';
      }
    };
  
    const scanDataByHost = scanData.reduce((acc, curr) => {
      if (!acc[curr.host]) {
        acc[curr.host] = [];
      }
      acc[curr.host].push(curr);
      return acc;
    }, {});
  
    const generateReportContent = async () => {
      try {
        const logoBase64 = await getBase64Image(logoUrl);
        const currentDate = new Date();
        const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
          dateStyle: 'full',
          timeStyle: 'long',
          timeZone: 'UTC'
        });
  
        const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Security Assessment Report - ${scanName}</title>
          <style>
            @import url('https://cdnjs.cloudflare.com/ajax/libs/tailwindcss/2.2.19/tailwind.min.css');
            
            body {
              font-family: 'Segoe UI', system-ui, sans-serif;
              background: #f8fafc;
              color: #1a202c;
              line-height: 1.5;
            }
  
            .page {
              width: 210mm;
              min-height: 297mm;
              padding: 20mm;
              margin: 10mm auto;
              background: white;
              box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);
              overflow-x: hidden;
            }
  
            .info-section {
              background-color: #f8f9fa;
              border-left: 4px solid #4a5568;
              padding: 1rem;
              margin-bottom: 2rem;
              font-size: 0.875rem;
              color: #4a5568;
            }
  
            .warning-section {
              background-color: #fff3cd;
              border-left: 4px solid #ffc107;
              padding: 1rem;
              margin-bottom: 2rem;
              font-size: 0.875rem;
              color: #856404;
            }
             .text-orange-800 {
            color: #fd7e14 !important;
          }
            .text-orange {
            color: #fd7e14 !important;
          }
          
          .bg-orange-100 {
            background-color: #fff3cd !important;
          }
          
          .text-orange-100 {
            color: #fff3cd !important;
          }

          .bg-orange-600 {
            background-color: #d96707 !important;
          }
          
          .text-orange-600 {
            color: #d96707 !important;
          }
          
          .text-orange-800 {
            color: #fd7e14 !important;
          }
          
          .bg-orange-500 {
            background-color: #fd7e14 !important;
          }
            .critical-section {
              background-color: #f8d7da;
              border-left: 4px solid #dc3545;
              padding: 1rem;
              margin-bottom: 2rem;
              font-size: 0.875rem;
              color: #721c24;
            }
  
            .host-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              background: #f8f9fa;
              border-left: 4px solid #4a5568;
              padding: 1rem;
              margin-bottom: 0;
            }
  
            .section-title {
              font-size: 1.25rem;
              font-weight: 600;
              color: #2d3748;
              margin-bottom: 1rem;
              padding-bottom: 0.5rem;
              border-bottom: 2px solid #e2e8f0;
            }
  
            .progress-multi {
              display: flex;
              height: 24px;
              overflow: hidden;
              font-size: 0.75rem;
              background-color: #e9ecef;
              border-radius: 0.25rem;
            }
  
            .progress-bar {
              display: flex;
              flex-direction: column;
              justify-content: center;
              overflow: hidden;
              color: #fff;
              text-align: center;
              white-space: nowrap;
              transition: width 0.6s ease;
            }
  
            .progress-bar-critical { background-color: #dc3545 !important; }
            .progress-bar-high { background-color: #fd7e14 !important; }
            .progress-bar-medium { background-color: #ffc107 !important; }
            .progress-bar-low { background-color: #28a745 !important; }
            .progress-bar-none { background-color: #6c757d !important; }
  
            .stat-card {
              background: white;
              border-radius: 8px;
              padding: 1.5rem;
              box-shadow: 0 1px 3px rgba(0,0,0,0.12);
              text-align: center;
            }
  
            .risk-badge {
              display: inline-block;
              padding: 0.25rem 0.75rem;
              border-radius: 9999px;
              font-weight: 600;
              font-size: 0.75rem;
              text-transform: uppercase;
              letter-spacing: 0.05em;
            }
  
            .risk-critical { 
              background-color: #dc3545; 
              color: white;
            }
            .risk-high { 
              background-color: #fd7e14; 
              color: white;
            }
            .risk-medium { 
              background-color: #ffc107; 
              color: black;
            }
            .risk-low { 
              background-color: #28a745; 
              color: white;
            }
            .risk-none { 
              background-color: #6c757d; 
              color: white;
            }
  
            .vuln-table {
              width: 100%;
              border-collapse: separate;
              border-spacing: 0;
              background: white;
              border-radius: 8px;
              overflow: hidden;
              margin-top: 1rem;
            }
  
            .vuln-table th {
              background: #f8f9fa;
              font-weight: 600;
              text-transform: uppercase;
              font-size: 0.75rem;
              letter-spacing: 0.05em;
              color: #4a5568;
              padding: 1rem;
              text-align: left;
              border-bottom: 2px solid #e2e8f0;
            }
  
            .vuln-table td {
              padding: 1rem;
              border-bottom: 1px solid #e2e8f0;
              font-size: 0.875rem;
              vertical-align: top;
            }
  
            .vuln-table tr:last-child td {
              border-bottom: none;
            }
  
            .vuln-table th:nth-child(1),
            .vuln-table td:nth-child(1) { width: 10%; }
            .vuln-table th:nth-child(2),
            .vuln-table td:nth-child(2) { width: 8%; }
            .vuln-table th:nth-child(3),
            .vuln-table td:nth-child(3) { width: 15%; }
            .vuln-table th:nth-child(4),
            .vuln-table td:nth-child(4) { width: 20%; }
            .vuln-table th:nth-child(5),
            .vuln-table td:nth-child(5) { width: 25%; }
            .vuln-table th:nth-child(6),
            .vuln-table td:nth-child(6) { width: 22%; }
  
            .summary-stats {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
              gap: 1.5rem;
              margin: 2rem 0;
            }
  
            .risk-summary {
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              color: white;
              border-radius: 12px;
              padding: 2rem;
              text-align: center;
            }
  
            .risk-summary-title {
              font-size: 0.875rem;
              text-transform: uppercase;
              letter-spacing: 0.1em;
              margin-bottom: 0.5rem;
            }
  
            .risk-summary-score {
              font-size: 3rem;
              font-weight: 700;
              line-height: 1;
              margin-bottom: 0.5rem;
            }
  
            .risk-summary-subtitle {
              font-size: 0.875rem;
              opacity: 0.9;
            }
  
            .collapsible-content {
              display: none;
              background: white;
              border: 1px solid #e2e8f0;
              border-top: none;
              border-radius: 0 0 8px 8px;
            }
  
            .collapsible-content.active {
              display: block;
            }
  
            @media print {
              body {
                background: white;
              }
              .page {
                width: 100%;
                margin: 0;
                padding: 15mm;
                box-shadow: none;
              }
            }
          </style>
          <script>
            function toggleCollapsible(hostId) {
              const content = document.getElementById('content-' + hostId);
              content.classList.toggle('active');
              const arrow = document.getElementById('arrow-' + hostId);
              arrow.textContent = content.classList.contains('active') ? '▼' : '▶';
            }
          </script>
        </head>
        <body>
          <div class="page">
            <!-- Header -->
            <div class="flex justify-between items-center mb-8">
              <img src="${logoBase64}" alt="Company Logo" style="max-height: 60px; width: auto;" />
              <div class="text-right">
                <div class="text-sm text-gray-600">Security Assessment Report</div>
                <div class="text-sm font-semibold">${dateTimeFormat.format(currentDate)} (UTC)</div>
              </div>
            </div>
  
            <!-- Disclaimer -->
            <div class="info-section">
              <p class="font-semibold mb-2">Disclaimer:</p>
              <p>This security assessment report provides a point-in-time analysis of the scanned systems and networks. The findings presented are based on automated scanning tools and may require further validation. This report should be treated as confidential and shared only with authorized personnel.</p>
            </div>
  
            <!-- Executive Summary -->
            <div class="critical-section">
              <p class="font-semibold mb-2">Executive Summary:</p>
              <p>This security assessment has identified ${totalIssues} vulnerabilities across ${Object.keys(scanDataByHost).length} hosts. The assessment reveals ${riskTotals.Critical || 0} critical, ${riskTotals.High || 0} high, and ${riskTotals.Medium || 0} medium risk vulnerabilities that require immediate attention.</p>
            </div>
  
            <!-- Methodology -->
            <div class="warning-section">
              <p class="font-semibold mb-2">Assessment Methodology:</p>
              <p>This assessment was conducted using automated security scanning tools and vulnerability assessment frameworks. The results have been analyzed and categorized based on industry-standard risk metrics and security best practices.</p>
            </div>
  
            <!-- Title Section -->
            <div class="mb-8">
              <h1 class="text-4xl font-bold text-gray-900 mb-4">Vulnerability Assessment Report</h1>
              <div class="flex gap-4 text-sm text-gray-600">
                <div>Scan ID: ${scanId}</div>
                <div>•</div>
                <div>Target: ${scanName}</div>
                <div>•</div>
                <div>Hosts Scanned: ${Object.keys(scanDataByHost).length}</div>
              </div>
            </div>
  
            <!-- Risk Summary -->
            <div class="mb-8">
              <h2 class="section-title">Risk Assessment Overview</h2>
              <!-- Key Stats Grid -->
            <div class="grid grid-cols-4 gap-4 mb-6">
              <div class="stat-card">
                <div class="text-3xl font-bold text-red-600">${riskTotals.High || 0}</div>
                <div class="text-sm text-gray-600">High Risk</div>
              </div>
              <div class="stat-card">
                <div class="text-3xl font-bold text-orange-600">${riskTotals.Medium || 0}</div>
                <div class="text-sm text-gray-600">Medium Risk</div>
              </div>
              <div class="stat-card">
                <div class="text-3xl font-bold text-yellow-500">${riskTotals.Low || 0}</div>
                <div class="text-sm text-gray-600">Low Risk</div>
              </div>
              <div class="stat-card">
                <div class="text-3xl font-bold text-green-500">${riskTotals.None || 0}</div>
                <div class="text-sm text-gray-600">No Risk</div>
              </div>
            </div>
          </div>
              
  
              <!-- Risk Distribution -->
              <div class="mt-8">
                <h3 class="text-lg font-semibold mb-2">Overall Risk Distribution</h3>
                <div class="progress-multi">
                  ${Object.entries(riskTotals).map(([risk, count]) => `
                    ${count > 0 ? `
                      <div class="progress-bar progress-bar-${risk.toLowerCase()}"
                           style="width: ${(count / totalIssues * 100).toFixed(1)}%"
                           title="${risk}: ${count}">
                        ${count}
                      </div>` : ''}
                  `).join('')}
                </div>
              </div>
  
              <!-- Top Vulnerabilities -->
              <div class="mt-8">
                <h3 class="text-lg font-semibold mb-2">Critical Findings</h3>
                <div class="info-section">
                  ${topVulnerabilities.map(vuln => `
                    <div class="mb-4 last:mb-0">
                      <div class="flex items-center gap-2 mb-1">
                        <span class="risk-badge risk-${vuln.risk?.toLowerCase() || 'none'}">${vuln.risk}</span>
                        <span class="font-medium">${vuln.name}</span>
                      </div>
                      <p class="text-sm">${vuln.synopsis}</p>
                    </div>
                  `).join('')}
                </div>

            <!-- Host Sections -->
            ${Object.keys(riskDistribution).map((host, index) => {
              const dist = riskDistribution[host];
              const total = dist.total || 1;
              const hostData = scanDataByHost[host] || [];

              return `
                <div id="host-${index}" class="collapsible">
                  <div class="collapsible-header" onclick="toggleCollapsible('${index}')">
  <div class="flex justify-between items-center cursor-pointer">
    <!-- Host Name -->
    <div class="flex-1">
      <h3 class="text-lg font-semibold">${host}</h3>
      <div class="progress-multi mt-2 flex gap-1">
        ${dist.High > 0 ? `
          <div class="progress-bar progress-bar-high" 
               style="width: ${(dist.High / total * 100).toFixed(1)}%">
            ${dist.High}
          </div>` : ''}
        ${dist.Medium > 0 ? `
          <div class="progress-bar progress-bar-medium" 
               style="width: ${(dist.Medium / total * 100).toFixed(1)}%">
            ${dist.Medium}
          </div>` : ''}
        ${dist.Low > 0 ? `
          <div class="progress-bar progress-bar-low" 
               style="width: ${(dist.Low / total * 100).toFixed(1)}%">
            ${dist.Low}
          </div>` : ''}
        ${dist.None > 0 ? `
          <div class="progress-bar progress-bar-none" 
               style="width: ${(dist.None / total * 100).toFixed(1)}%">
            ${dist.None}
          </div>` : ''}
        ${dist.Null > 0 ? `
          <div class="progress-bar progress-bar-null" 
               style="width: ${(dist.Null / total * 100).toFixed(1)}%">
            ${dist.Null}
          </div>` : ''}
      </div>
    </div>
    
    <!-- Arrow Icon -->
    <div class="ml-4">
      <span class="text-gray-500 transform transition-transform duration-300" id="arrow-${index}">
        &#x25BC; <!-- Down arrow -->
      </span>
    </div>
  </div>
</div>

                 
                  <div id="content-${index}" class="collapsible-content">
                    <table class="vuln-table">
                      <thead>
                        <tr>
                          <th>Risk</th>
                          <th>Port</th>
                          <th>Name</th>
                          <th>Solution</th>
                        </tr>
                      </thead>
                      <tbody>
                        ${hostData.map(vuln => `
                          <tr>
                            <td>
                              <span class="risk-badge risk-${vuln.risk?.toLowerCase() || 'none'}">
                                ${vuln.risk || 'None'}
                              </span>
                            </td>
                            <td>${vuln.port}</td>
                            <td>${vuln.name}</td>
                            <td>${vuln.solution}</td>
                          </tr>
                        `).join('')}
                      </tbody>
                    </table>
                  </div>
                </div>
              `;
            }).join('')}
          </body>
          </html>
    `;

        // Create blob and download
        const blob = new Blob([htmlContent], { type: 'text/html' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `security-report-${scanId}.html`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error generating report:', error);
      } finally {
        setIsExporting(false);
      }
    };;

    generateReportContent();
  };



  const getRiskColor = (risk) => {
    switch (risk) {
      case "High":
        return "text-danger fw-bold";
      case "Medium":
        return "text-warning fw-bold";
      case "Low":
        return "text-success fw-bold";
      case "None":
        return "text-primary fw-bold";
      default:
        return "text-secondary fw-bold";
    }
  };


  useEffect(() => {
    const fetchResults = async () => {
      try {
        const jsonData = await fetchScanResults(userId, scanId);
        setScanName(jsonData.Basic.Name);
        setScanType(jsonData.mainscanType || "");
        setJsonData(jsonData);

        if (jsonData.mainscanType !== "SBOM") {
          const data = generateRandomData(jsonData);
          setScanData(data);
        }
        setLoading(false);
      } catch (err) {
        setError("Analysis in Progress");
        setLoading(false);
      }
    };
    fetchResults();
  }, [userId, scanId]);

  const riskDistribution = calculateRiskDistribution(scanData);

  const columns = React.useMemo(
    () => [
      { Header: "Host", accessor: "host" },
      {
        Header: "Risk", accessor: "risk", Cell: ({ value }) => (
          <span className={getRiskColor(value)}>{value || "N/A"}</span>
        ),
      },
      { Header: "Port", accessor: "port" },
      { Header: "Name", accessor: "name" },
      { Header: "Synopsis", accessor: "synopsis" },
      { Header: "Description", accessor: "description" },
      { Header: "Solution", accessor: "solution" },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data: scanData,
        initialState: { sortBy: [{ id: "risk", desc: false }] },
      },
      useSortBy
    );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={scanName} breadcrumbItem={scanId} />
          {(loading || error) && (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                minHeight: "100vh",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-10%, -50%)",
              }}
            >
              <div className="text-center">
                <h4>{loading ? "Loading scan results..." : error}</h4>
                <Spinner
                  color="primary"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    animationDuration: "1.5s",
                    borderWidth: "0.5rem",
                  }}
                />
              </div>
            </div>
          )}

          {!loading && !error && scanType === "SBOM" ? (
            <VulnerabilitySummary data={jsonData} />

          ) : (
            !loading &&
            !error && (
              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      <div className="d-flex justify-content-between align-items-center">
                        <h4 className="card-title">Scan Results for {scanName}</h4>
                        <Button
                          color="primary"
                          disabled={isExporting}
                          className="mb-3"
                          onClick={exportReport}
                        >
                          {isExporting ? (
                            <>
                              <Spinner size="sm" className="me-2" />
                              <span>Generating Report...</span>
                            </>
                          ) : (
                            "Export Report"
                          )}
                        </Button>
                      </div>
                      <div id="scan-results-content">
                        <p className="text-muted">
                          Scan Date: {new Date().toLocaleDateString()}
                        </p>
                        <Nav tabs className="nav-tabs-custom">
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "summary",
                              })}
                              onClick={() => setActiveTab("summary")}
                            >
                              Summary
                            </NavLink>
                          </NavItem>
                          {/* <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "hosts",
                              })}
                              onClick={() => setActiveTab("hosts")}
                            >
                              Hosts
                            </NavLink>
                          </NavItem> */}
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "vulnerabilities",
                              })}
                              onClick={() => setActiveTab("vulnerabilities")}
                            >
                              Vulnerabilities
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId="summary">
                            <Card>
                              {Object.keys(riskDistribution).map((host) => {
                                const distribution = riskDistribution[host];
                                const total = distribution.total || 1;
                                return (
                                  <div key={host} className="mt-3">
                                    <br />
                                    <h6>Risk Distribution: {host} </h6>
                                    <Progress multi style={{ height: "1.5rem" }}>
                                      <Progress
                                        bar
                                        color="success"
                                        value={(distribution.Low / total) * 100}
                                      >
                                        {distribution.Low}
                                      </Progress>
                                      <Progress
                                        bar
                                        color="warning"
                                        value={
                                          (distribution.Medium / total) * 100
                                        }
                                      >
                                        {distribution.Medium}
                                      </Progress>
                                      <Progress
                                        bar
                                        color="danger"
                                        value={(distribution.High / total) * 100}
                                      >
                                        {distribution.High}
                                      </Progress>
                                      <Progress
                                        bar
                                        color="primary"
                                        value={(distribution.None / total) * 100}
                                      >
                                        {distribution.None}
                                      </Progress>
                                      <Progress
                                        bar
                                        color="secondary"
                                        value={(distribution.Null / total) * 100}
                                      >
                                        {distribution.Null}
                                      </Progress>
                                    </Progress>
                                  </div>
                                );
                              })}

                            </Card>
                            <hr />
                            <SummaryTab scanData={scanData} />
                          </TabPane>
                          {/* <TabPane tabId="hosts">
                            {Object.keys(riskDistribution).map((host) => {
                              const distribution = riskDistribution[host];
                              const total = distribution.total || 1;
                              return (
                                <div key={host} className="mt-3">
                                  <h6>{host} Risk Distribution</h6>
                                  <Progress multi style={{ height: "1.5rem" }}>
                                    <Progress
                                      bar
                                      color="success"
                                      value={(distribution.Low / total) * 100}
                                    >
                                      {distribution.Low}
                                    </Progress>
                                    <Progress
                                      bar
                                      color="warning"
                                      value={
                                        (distribution.Medium / total) * 100
                                      }
                                    >
                                      {distribution.Medium}
                                    </Progress>
                                    <Progress
                                      bar
                                      color="danger"
                                      value={(distribution.High / total) * 100}
                                    >
                                      {distribution.High}
                                    </Progress>
                                    <Progress
                                      bar
                                      color="primary"
                                      value={(distribution.None / total) * 100}
                                    >
                                      {distribution.None}
                                    </Progress>
                                    <Progress
                                      bar
                                      color="secondary"
                                      value={(distribution.Null / total) * 100}
                                    >
                                      {distribution.Null}
                                    </Progress>
                                  </Progress>
                                </div>
                              );
                            })}
                          </TabPane> */}
                          <TabPane tabId="vulnerabilities">
                            <Card>
                              <CardBody >
                                <h5 className="font-weight-semibold">
                                  Vulnerabilities
                                </h5>
                                <Table {...getTableProps()}>
                                  <thead>
                                    {headerGroups.map((headerGroup) => (
                                      <tr
                                        {...headerGroup.getHeaderGroupProps()}
                                        key={headerGroup.id}
                                      >
                                        {headerGroup.headers.map((column) => (
                                          <th
                                            {...column.getHeaderProps(
                                              column.getSortByToggleProps()
                                            )}
                                            key={column.id}
                                          >
                                            {column.render("Header")}

                                          </th>
                                        ))}
                                      </tr>
                                    ))}
                                  </thead>
                                  <tbody {...getTableBodyProps()}>
                                    {rows.map((row) => {
                                      prepareRow(row);
                                      return (
                                        <tr {...row.getRowProps()} key={row.id}>
                                          {row.cells.map((cell) => (
                                            <td {...cell.getCellProps()} key={cell.id} style={{ textAlign: "justify" }}>
                                              {cell.render("Cell")}

                                            </td>
                                          ))}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </Table>
                              </CardBody>
                            </Card>
                          </TabPane>
                        </TabContent>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ScanResults;
